module.exports = __webpack_public_path__ + "downloads/Factor.4d37e426.xlsx";